import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import { translate as translateComponent } from 'react-admin';
import { nanoid } from 'nanoid';
import { useQuery } from '@tanstack/react-query';
import { getUser } from '../../../../user';
import { fetchCdpJson, cdpRetry } from '../../../../helpers/cdp';

const BadgeFormButton = ({ className, record, translate }) => {
  const CARE_DATA_PARSER_BADGES_URL = '/cdp/badges';
  const user = getUser();

  const today = new Date();
  const year = new Intl.DateTimeFormat('fr', { year: 'numeric' }).format(today);
  const month = new Intl.DateTimeFormat('fr', { month: 'long' }).format(today);
  const day = new Intl.DateTimeFormat('fr', { day: '2-digit' }).format(today);
  const todayString = `${day} ${month} ${year}`;

  const { data: badgesList, isLoading, isError, error } = useQuery({
    queryKey: ['badges', record?.id],
    queryFn: async () => {
      return fetchCdpJson(CARE_DATA_PARSER_BADGES_URL);
    },
    enabled: !!record?.id,
    retry: cdpRetry,
    select: (data) => {
      return Array.isArray(data) ? data : [];
    },
  });

  const currentAssignedBadge = (badgesList || []).find((badge) => {
    return badge.externalReferences?.CleanerId === record?.id;
  });

  const address = `${record?.mailing_street} ${record?.mailing_city} ${record?.mailing_postal_code}`;
  const id = nanoid(18);

  const formUrl = 'https://forms.cleany.fr/remise-de-badge';
  const params =
    `?formId=${id}&employeeSilaeId=${record?.silae_id}` +
    `&todayDate=${todayString}&employeeFullname=${record?.fullname}&employeeAddress=${address}` +
    `&employeeBadgeId=${currentAssignedBadge?.pin}&issuerFullname=${user?.fullname}`;

  if (isLoading) return <p>Chargement...</p>;
  if (isError) {
    return (
      <p style={{ color: '#d9534f', margin: 0, padding: '6px 16px' }}>
        {error?.message || 'Erreur lors du chargement des badges'}
      </p>
    );
  }

  return (
    <Fragment>
      <Route
        render={() => {
          return (
            <MenuItem
              className={className}
              variant="contained"
              onClick={() => {
                if (currentAssignedBadge) {
                  window.open(`${formUrl}${params}`);
                } else {
                  window.alert(
                    `Pas de badge affecté pour l'agent, affectez un badge avant d'ouvrir le formulaire`,
                  );
                }
              }}
            >
              <ListItemText primary="Formulaire de remise de badge" />
            </MenuItem>
          );
        }}
      />
    </Fragment>
  );
};

BadgeFormButton.propTypes = {
  className: PropTypes.string,
  record: PropTypes.object,
  translate: PropTypes.func,
};

BadgeFormButton.defaultProps = {
  className: undefined,
  record: undefined,
  translate: /* istanbul ignore next */ () => {},
};

export default translateComponent(BadgeFormButton);
